import { StorageKey, setSessionStorage } from '@utils/StorageUtils';
import { HitlistsRetailerClientState } from '../../reducers/hitlist-retailer-client/HitlistsRetailerClientReducer';
import { HitlistsRetailerClientTypes } from '../Type';

export const updateHitlistsRetailerClient = (payload: HitlistsRetailerClientState) => {
  return (dispatch: any) => {
    dispatch({
      type: HitlistsRetailerClientTypes.HitlistsRetailerClientUpdate,
      payload,
    });
    setSessionStorage(StorageKey.HitlistsRetailerClient, JSON.stringify(payload));
  };
};
